import { TableColumnsType, Tag, Tooltip } from "antd";
import TableUi from "../../../../../atoms/Table";
import Filters from "./Components/Filters";
import { useState } from "react";
import { WODetailType } from "../../../ducks/types";
import { PlusIcon } from "../../../../../atoms/CustomIcons";
import EmptyCard from "../../../../../atoms/EmptyCard";

interface PropsType {
  woDetailData: WODetailType | null;
}

export default function Materials(props: PropsType) {
  const { woDetailData } = props;
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(10);
  const [archived, isArchived] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);

  const [filters, setFilters] = useState<{
    type: undefined | string;
    status: undefined | string[];
    state: undefined;
    city: undefined;
    last_user_activity: string[] | undefined;
    onboarding_complete_date: string[] | undefined;
    search_text: undefined | string;
  }>({
    type: undefined,
    status: undefined,
    state: undefined,
    city: undefined,
    last_user_activity: undefined,
    onboarding_complete_date: undefined,
    search_text: undefined,
  });

  const columns: TableColumnsType = [
    {
      title: "Material name",
      dataIndex: "name",
      width: 240,
      fixed: "left",
      render: (text: string) => (
        <Tooltip title={text ? text : "-"}>
          <span className="table-col-ellipsis" style={{ maxWidth: "230px" }}>
            {text ? text : "-"}
          </span>
        </Tooltip>
      ),
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    {
      title: "Subservices",
      dataIndex: "subServices",
      width: 240,
      render: (text: string[]) =>
        text?.length > 0 ? (
          <div style={{ display: "flex", gap: "4px" }}>
            {text?.slice(0, 1).map((item: string) => {
              return (
                <Tag key={item} style={{ textTransform: "capitalize" }}>
                  {item}
                </Tag>
              );
            })}

            {text?.length > 1 && (
              <Tooltip
                title={text
                  ?.slice(1)
                  ?.map((item: string) => {
                    return item;
                  })
                  ?.join(", ")}
              >
                <Tag
                  style={{
                    background: "#EFF2F3",
                    color: "#151718",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  +{text?.length - 1}
                </Tag>
              </Tooltip>
            )}
          </div>
        ) : (
          "-"
        ),
      fixed: "left",
      sorter: (a, b) => a?.subservices?.localeCompare(b?.subservices),
    },
    {
      title: "Unit",
      dataIndex: "unit",
      width: 64,
      sorter: (a, b) => a?.unit?.localeCompare(b?.unit),
    },
    {
      title: "Estimated",
      dataIndex: "estimated",
      width: 140,
      render: (text) =>
        text ? Number(text?.toFixed(2))?.toLocaleString() : "-",
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.estimated?.localeCompare(b?.estimated),
    },
    {
      title: "Allocated",
      dataIndex: "allocated",
      width: 140,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.allocated?.localeCompare(b?.allocated),
    },
    {
      title: "On order",
      dataIndex: "on_order",
      width: 140,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.on_order?.localeCompare(b?.on_order),
    },
    {
      title: "Used to date",
      dataIndex: "used_to_date",
      width: 140,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.used_to_date?.localeCompare(b?.used_to_date),
    },
    {
      title: "Purchase orders",
      dataIndex: "purchase_orders",
      width: 200,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.purchase_orders?.localeCompare(b?.purchase_orders),
    },
    {
      title: "",
      dataIndex: "create_po",
      width: 200,
      render: () => (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            cursor: "pointer",
            fontWeight: 500,
          }}
        >
          <PlusIcon /> Create PO
        </span>
      ),
      sorter: (a, b) => a?.create_po?.localeCompare(b?.create_po),
    },
  ];

  return (
    <div className="workOrderMaterial">
      <h3 style={{ position: "absolute", top: "5px" }}> Materials </h3>
      {woDetailData?.contractMaterials &&
      woDetailData?.contractMaterials?.length > 0 ? (
        <TableUi
          columns={columns}
          data={{
            count: woDetailData?.contractMaterials?.length || 0,
            data: woDetailData?.contractMaterials || [],
          }}
          filters={
            <Filters
              setFilters={setFilters}
              filters={filters}
              archived={archived}
              isArchived={isArchived}
            />
          }
          pageSize={limit}
          setPageSize={setLimit}
          setCurrentPage={setPagination}
          currentPage={pagination}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      ) : (
        <div className="empty_wrap">
          <EmptyCard
            imageHeight={180}
            title={
              archived
                ? "There are no archived materials"
                : filters?.search_text
                ? "No results match the filter or search criteria"
                : `There are no ${filters?.status ?? ""} materials`
            }
            description={
              archived
                ? "We believe in our absolute success and hope to never have any archived materials here."
                : filters?.search_text
                ? "Try adjusting the filters and search."
                : ""
            }
            image={
              archived
                ? "/images/empty-icons/no-archived.svg"
                : "/images/empty-icons/no-active.svg"
            }
          />
        </div>
      )}
    </div>
  );
}
